// extracted by mini-css-extract-plugin
export default {"textInput":"TextInputCell_textInput__5eZUO","placeholderRow":"TextInputCell_placeholderRow__7MeGq","rightTextAlign":"TextInputCell_rightTextAlign__568oo"};